import { render, staticRenderFns } from "./BigCartItem.vue?vue&type=template&id=03826354&"
import script from "./BigCartItem.vue?vue&type=script&lang=js&"
export * from "./BigCartItem.vue?vue&type=script&lang=js&"
import style0 from "./BigCartItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports